import axios from 'axios'

export default {
  namespaced: true,
  state: {
    id: '',
    name: '',
    data: '',
    language: 'fr'
  },
  getters: {
    get: state => {
      return state.data
    },
    getLanguage: state => {
      return state.language
    }
  },
  actions: {
    load: ({ commit, state }) => {
      axios
        .get(process.env.VUE_APP_API + `/user/${state.id}?_format=json`)
        .then(user => {
          axios
            .get(
              process.env.VUE_APP_API +
                `/taxonomy/term/${user.data.field_profession[0].target_id}?_format=json`
            )
            .then(profession => {
              commit('set', {
                id: user.data.uid[0].value,
                name: user.data.name[0].value,
                data: {
                  firstname: user.data.field_firstname[0].value,
                  lastname: user.data.field_lastname[0].value,
                  picture: user.data.user_picture,
                  profession: profession.data.name[0].value
                }
              })
            })
        })
    },
    patch: ({ dispatch, state }, data) => {
      return new Promise((resolve, reject) => {
        if (data === null) {
          axios
            .patch(
              process.env.VUE_APP_API + '/user/' + state.id + '?_format=json',
              { user_picture: [] }
            )
            .then(() => {
              dispatch('load')
            })
            .catch(error => {
              reject(error)
            })
        } else {
          var map = {
            a: 'á|à|ã|â|À|Á|Ã|Â',
            e: 'é|è|ê|É|È|Ê',
            i: 'í|ì|î|Í|Ì|Î',
            o: 'ó|ò|ô|õ|Ó|Ò|Ô|Õ',
            u: 'ú|ù|û|ü|Ú|Ù|Û|Ü',
            c: 'ç|Ç',
            n: 'ñ|Ñ'
          }

          let filename = state.data.firstname + state.data.lastname
          filename = filename.toLowerCase()

          for (var pattern in map) {
            filename = filename.replace(new RegExp(map[pattern], 'g'), pattern)
          }

          axios
            .post(
              process.env.VUE_APP_API +
                '/file/upload/user/user/user_picture?_format=json',
              data,
              {
                headers: {
                  'Content-Type': 'application/octet-stream',
                  'Content-Disposition': `file; filename="${filename}.jpg"`
                }
              }
            )
            .then(response => {
              const fid = response.data.fid[0].value,
                fids = [...state.data.picture, ...[{ target_id: fid }]]

              axios
                .patch(
                  process.env.VUE_APP_API +
                    '/user/' +
                    state.id +
                    '?_format=json',
                  { user_picture: fids }
                )
                .then(() => {
                  dispatch('load')
                  resolve()
                })
                .catch(error => {
                  reject(error)
                })
            })
            .catch(error => {
              reject(error)
            })
        }
      })
    },
    changeLanguage({ commit }, language) {
      commit('changeLanguage', language)
    }
  },
  mutations: {
    set: (state, { id, name, data }) => {
      state.id = id
      state.name = name
      state.data = data
    },
    clear: state => {
      state.name = ''
      state.id = ''
      state.data = ''
    },
    changeLanguage: (state, language) => {
      state.language = language
    }
  }
}
